import {IsockMessage} from "../iframe-sock/iframeSocket";
import {IOpsSdk} from "../types";

export const METHOD_SET_PLUGIN_LOADED = 'setPluginLoaded';
export const METHOD_GET_USER_NAME = 'getUserName';
export const METHOD_GET_USER = 'getUser';
export const METHOD_GET_USER_ID = 'getUserId';
export const METHOD_GET_PLUGINS = 'getPlugins';
export const METHOD_GET_PLUGIN = 'getPlugin';
export const METHOD_GET_PORTAL_URL = 'getPortalURL';
export const METHOD_GET_COUNTRIES = 'getCountries';
export const METHOD_GET_ACCESS_TOKEN = 'getAccessToken';
export const METHOD_GET_REFRESHED_ACCESS_TOKEN = 'getRefreshedAccessToken';
export const METHOD_REFRESH_ACCESS_TOKEN = 'refreshAccessToken';
export const METHOD_GET_MUI_THEME = 'getMuiTheme';
export const METHOD_EXTEND_MUI_THEME = 'extendMuiTheme';
export const METHOD_GET_COUNTRY = 'getCountry';
export const METHOD_GET_LANGUAGE = 'getLanguage';
export const METHOD_GET_LOCALES_BY_COUNTRY = 'getLocalesByCountry';
export const METHOD_GET_ENTITY_ID = 'getEntityId';
export const METHOD_GET_BRAND_NAME = 'getBrandName';
export const METHOD_GET_MARKET_NAME = 'getMarketName';
export const METHOD_TRANSLATE = 'translate';
export const METHOD_CALL = 'call';
export const METHOD_GET_CANCEL_TOKEN_SOURCE = 'getCancelTokenSource';
export const METHOD_SWITCH_PLUGIN = 'switchPlugin';
export const METHOD_SWITCH_COUNTRY = 'switchCountry';
export const METHOD_PLUGIN_URL_SET = 'pluginUrl.set';
export const METHOD_PLUGIN_URL_GET = 'pluginUrl.get';
export const METHOD_ADD_EVENT_LISTENER = 'addEventListener';
export const METHOD_REMOVE_EVENT_LISTENER = 'removeEventListener';
export const METHOD_GET_GOOGLE_TOKEN = 'getGoogleToken';
export const METHOD_REFRESH_GOOGLE_TOKEN = 'refreshGoogleToken';
export const METHOD_GET_OKTA_TOKEN = 'getOktaToken';
export const METHOD_GET_I18N_RESOURCE = 'getI18nResource';
export const METHOD_GET_THEME_OPTIONS = 'getThemeOptions';
export const METHOD_ALERT_SET = 'alert.set';
export const METHOD_ALERT_REMOVE = 'alert.remove';
export const METHOD_PUSH_GTM_DATA_LAYER = 'pushGtmDataLayer';
export const METHOD_PUSH_GTM_EVENT = 'pushGtmEvent';
export const METHOD_AUDIT_LOG_OPEN = 'auditLog.open';
export const METHOD_GET_ENVIRONMENT = 'getEnvironment';
export const METHOD_GET_REGION = 'getRegion';
export const METHOD_GET_CONFIGURATION = 'getConfiguration';
export const METHOD_LOG_ERROR_OBJECT = 'logErrorObject';
export const METHOD_GET_FEATURE = 'getFeature';

type SyncSDKMethod = (m: IsockMessage, sdk: IOpsSdk) => any;

export const syncSDKMethods = new Map<string, SyncSDKMethod>();

syncSDKMethods.set(
    METHOD_SET_PLUGIN_LOADED,
    (m: IsockMessage, sdk: IOpsSdk) => {
        sdk.setPluginLoaded();
        return null;
    }
);

syncSDKMethods.set(
    METHOD_GET_USER_NAME,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getUserName()
);

syncSDKMethods.set(
    METHOD_GET_USER,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getUser()
);

syncSDKMethods.set(
  METHOD_GET_USER_ID,
  (m: IsockMessage, sdk: IOpsSdk) => sdk.getUserId()
);

syncSDKMethods.set(
    METHOD_GET_PLUGINS,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getPlugins()
);

syncSDKMethods.set(
    METHOD_GET_PLUGIN,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getPlugin()
);

syncSDKMethods.set(
    METHOD_GET_COUNTRIES,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getCountries()
);

syncSDKMethods.set(
    METHOD_GET_ACCESS_TOKEN,
    (m: IsockMessage, sdk: IOpsSdk) => {
        try {
            return sdk.getAccessToken()
        } catch (e) {
            return e.toString();
        }
    }
);

syncSDKMethods.set(
    METHOD_GET_COUNTRY,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getCountry()
);

syncSDKMethods.set(
    METHOD_GET_LANGUAGE,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getLanguage()
);

syncSDKMethods.set(
    METHOD_GET_LOCALES_BY_COUNTRY,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getLocalesByCountry()
);

syncSDKMethods.set(
    METHOD_GET_ENTITY_ID,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getEntityId()
);

syncSDKMethods.set(
    METHOD_GET_BRAND_NAME,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getBrandName()
);

syncSDKMethods.set(
  METHOD_GET_MARKET_NAME,
  (m: IsockMessage, sdk: IOpsSdk) => sdk.getMarketName()
);

syncSDKMethods.set(
    METHOD_GET_MUI_THEME,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getMuiTheme()
);

syncSDKMethods.set(
    METHOD_TRANSLATE,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.translate(m.payload.key as string)
);

syncSDKMethods.set(
    METHOD_SWITCH_PLUGIN,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.portal.switchPlugin(m.payload.pluginId as string)
);

syncSDKMethods.set(
    METHOD_SWITCH_COUNTRY,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.portal.switchCountry(m.payload.countryCode as string)
);

syncSDKMethods.set(
    METHOD_PLUGIN_URL_SET,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.portal.pluginUrl.set(m.payload.url as string)
);

syncSDKMethods.set(
    METHOD_PLUGIN_URL_GET,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.portal.pluginUrl.get()
);

syncSDKMethods.set(
    METHOD_GET_GOOGLE_TOKEN,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getGoogleToken()
);

syncSDKMethods.set(
    METHOD_GET_OKTA_TOKEN,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getOktaToken()
);

syncSDKMethods.set(
    METHOD_GET_I18N_RESOURCE,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getI18nResource()
);

syncSDKMethods.set(
    METHOD_GET_THEME_OPTIONS,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getThemeOptions()
);

syncSDKMethods.set(
    METHOD_EXTEND_MUI_THEME,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.extendMuiTheme(m.payload.options)
);

syncSDKMethods.set(
    METHOD_ALERT_SET,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.alert.set(m.payload.msg, m.payload.options)
);

syncSDKMethods.set(
    METHOD_ALERT_REMOVE,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.alert.remove(m.payload.key)
);

syncSDKMethods.set(
    METHOD_PUSH_GTM_DATA_LAYER,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.pushGtmDataLayer(m.payload.dataLayer, m.payload.layerName)
);

syncSDKMethods.set(
    METHOD_PUSH_GTM_EVENT,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.pushGtmEvent(m.payload.name, m.payload.data)
);

syncSDKMethods.set(
    METHOD_GET_CANCEL_TOKEN_SOURCE,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getCancelTokenSource()
);

syncSDKMethods.set(
    METHOD_GET_PORTAL_URL,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.portal.getUrl()
);

syncSDKMethods.set(
    METHOD_AUDIT_LOG_OPEN,
    (m: IsockMessage, sdk: IOpsSdk) =>
        sdk.auditLog.open(
            m.payload.schemaName,
            m.payload.columns,
            m.payload.parameters,
            m.payload.flags,
        )
);

syncSDKMethods.set(
    METHOD_GET_ENVIRONMENT,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getEnvironment()
);

syncSDKMethods.set(
    METHOD_GET_REGION,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getRegion()
);

syncSDKMethods.set(
    METHOD_GET_CONFIGURATION,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.getConfiguration()
);

syncSDKMethods.set(
    METHOD_LOG_ERROR_OBJECT,
    (m: IsockMessage, sdk: IOpsSdk) => sdk.logErrorObject(m.payload.error)
);
